import React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { ForgotPasswordForm, LoginContainer } from "components/Login";
import backgroundImage from "assets/images/Faith-2000x1340-c-center.jpg";

/**
 * Forgot Password
 */
const ForgotPassword = () => {
  const intl = useIntl();
  const selectedBanner = banners[0];

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.ForgotPassword.Title" })}</title>
      </Helmet>
      <LoginContainer title="Login.H1" banner={selectedBanner}>
        <ForgotPasswordForm />
      </LoginContainer>
    </>
  );
};

const banners = [
  {
    title: "Built to support careers, not gigs.",
    label: "Faith Adekogbe",
    description: "Frontend Developer",
    cover: `url(${backgroundImage})`,
  },
];

export default ForgotPassword;
